import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import {
  Grid,
  Row,
  Col
} from 'react-bootstrap';

import EditProfileForm from '../../components/EditProfileForm';
import DashBoardSideMenu from '../../components/Dashboard/DashBoardSideMenu';

import s from './EditProfile.css';

class EditProfile extends React.Component {

  render() {
    return (
      <>
        <Grid fluid className={'dashBoardContainer'}>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12} className={'dashBoardGrid'}>
              <div>
                <DashBoardSideMenu />
              </div>
              <EditProfileForm />
            </Col>
          </Row>
        </Grid>
      </>
    );
  }
}

export default withStyles(s)(EditProfile);
